import { fromJS } from 'immutable'
import {
  EMPLOYEE_LEVELS_EXPORT_REQUEST,
  EMPLOYEE_LEVELS_EXPORT_SUCCESS,
  EMPLOYEE_LEVELS_EXPORT_FAILURE,
  EMPLOYEE_LEVELS_EXPORT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case EMPLOYEE_LEVELS_EXPORT_REQUEST:
      return state
        .set('isFetching', true)
    case EMPLOYEE_LEVELS_EXPORT_SUCCESS:
      return state
        .set('url', fromJS(action.payload.url))
        .set('isFetching', false)
    case EMPLOYEE_LEVELS_EXPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case EMPLOYEE_LEVELS_EXPORT_RESET:
      return state
        .delete('url')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee-levels/employee-levels-export-reducer.js